export type UrlIssueIndexParams = {
  owner: string
  repo: string
}

export type IssueSearchTypeVariant = 'ISSUE_HYBRID' | 'ISSUE_ADVANCED'

// The search type the client requests is resolved by Rails: ISSUE_HYBRID when hybrid/semantic
// search is available (the dotcom default) and ISSUE_ADVANCED otherwise (e.g. single-tenant
// enterprise or when the semantic endpoint is unavailable). Consumers that can't read that value
// (the service worker) default to ISSUE_HYBRID here and try both variants when looking up keys.
// `issues_default_best_match_sort` is assumed fully enabled. `showIssueFieldPills` is always
// `true` since the `issue_fields_index_pills` flag has been graduated.
export const getIssueIndexPageQueryDefaultValues = (
  {owner, repo}: UrlIssueIndexParams,
  issueSearchType: IssueSearchTypeVariant = 'ISSUE_HYBRID',
) => ({
  query: `is:issue state:open repo:${owner}/${repo} sort:relevance-desc`,
  first: 25,
  labelPageSize: 20,
  showIssueFieldPills: true,
  skip: 0,
  type: issueSearchType,
})
